<!-- <div class="cerebral-page">
  <div class="cerebral-search-bar">
    <input
      type="text"
      class="cerebral-search-input"
      placeholder="Tanı, ilaç, alerji, hastalık veya notlarda ara..."
      [(ngModel)]="searchText"
      (input)="onSearchChange()"
    />
  </div>

  <div class="cerebral-layout">
    <div class="cerebral-left">
      <ng-container *ngIf="filteredVisits.length > 0; else noResult">
        <div
          *ngFor="let visit of filteredVisits"
          class="visit-card"
          [class.active]="visit === selectedVisit"
          (click)="selectVisit(visit)"
        >
          <div class="visit-top">
            <div class="visit-location">
              {{ visit.hospitalDistrict || '-' }}
            </div>
            <div class="visit-date">
              {{ visit.visitDate || '-' }}
            </div>
          </div>

          <div class="visit-doctor">
            {{ visit.doctorName || '-' }}
          </div>

          <div class="visit-department">
            {{ visit.department || '-' }}
          </div>
        </div>
      </ng-container>

      <ng-template #noResult>
        <div class="empty-state">
          Aramaya uygun kayıt bulunamadı.
        </div>
      </ng-template>
    </div>

    <div class="cerebral-right" *ngIf="selectedVisit as v">
      <div class="detail-list">
        <div class="detail-row">
          <div class="detail-label">Tanı:</div>
          <div class="detail-value" [innerHTML]="highlight(v.diagnosis)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Yakınma:</div>
          <div class="detail-value" [innerHTML]="highlight(v.complaint)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Öykü:</div>
          <div class="detail-value" [innerHTML]="highlight(v.history)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Özgeçmiş Notu:</div>
          <div class="detail-value" [innerHTML]="highlight(v.medicalHistoryNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Sigara Kullanımı:</div>
          <div class="detail-value">{{ v.smokingUsage || '-' }}</div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Alkol Kullanımı:</div>
          <div class="detail-value">{{ v.alcoholUsage || '-' }}</div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Alerjiler:</div>
          <div class="detail-value" [innerHTML]="highlight(v.allergies)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Kronik Hastalıklar:</div>
          <div class="detail-value" [innerHTML]="highlight(v.chronicDiseases)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Ameliyat:</div>
          <div class="detail-value" [innerHTML]="highlight(v.surgery)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Ameliyat Geçmişi:</div>
          <div class="detail-value" [innerHTML]="highlight(v.surgeryHistory)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Soygeçmiş Notu:</div>
          <div class="detail-value" [innerHTML]="highlight(v.familyHistoryNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Muayene/Kontrol Notu:</div>
          <div class="detail-value" [innerHTML]="highlight(v.examinationControlNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Tetkik Önerisi:</div>
          <div class="detail-value" [innerHTML]="highlight(v.testRecommendation)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Konsültasyon:</div>
          <div class="detail-value" [innerHTML]="highlight(v.consultation)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Tedavi Notu:</div>
          <div class="detail-value" [innerHTML]="highlight(v.treatmentNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Sürekli Kullanılan İlaçlar:</div>
          <div class="detail-value" [innerHTML]="highlight(v.continuousMedications)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Reçete:</div>
          <div class="detail-value">{{ v.prescription || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<!-- <app-loadig-spinner *ngIf="loading"></app-loadig-spinner> -->
<app-loading
  [loading]="loading"
>
</app-loading>
<div class="cerebral-page" *ngIf="visits.length && isSuccess && !loading">

  <div class="cerebral-search-bar">
    <input type="text" class="cerebral-search-input" placeholder="Tanı, ilaç, alerji, hastalık veya notlarda ara..."
      [(ngModel)]="searchText" (input)="onSearchChange()" />
  </div>

  <div class="cerebral-layout">

    <div class="cerebral-left">

      <ng-container *ngIf="filteredVisits.length; else noResult">

        <div *ngFor="let visit of filteredVisits" class="visit-card" [class.active]="selectedVisit === visit"
          (click)="selectVisit(visit)">
          <div class="visit-top">
            <div class="visit-location">
              {{ visit.facilityName || '-' }}
            </div>

            <div class="visit-date">
              {{ visit.date || '-' }}
            </div>
          </div>

          <div class="visit-doctor">
            {{ visit.doctorName || '-' }}
          </div>

          <div class="visit-department">
            {{ visit.serviceName || '-' }}
          </div>
        </div>

      </ng-container>

      <ng-template #noResult>
        <div class="empty-state">
          Aramaya uygun kayıt bulunamadı.
        </div>
      </ng-template>

    </div>

    <div class="cerebral-right" *ngIf="selectedVisit as v">

      <div class="detail-list">

        <div class="detail-row">
          <div class="detail-label">Tanı:</div>
          <div class="detail-value" [innerHTML]="highlight(v.diagnosis)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Yakınma:</div>
          <div class="detail-value" [innerHTML]="highlight(v.complaint)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Öykü:</div>
          <div class="detail-value" [innerHTML]="highlight(v.story)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Özgeçmiş:</div>
          <div class="detail-value" [innerHTML]="highlight(v.resumeNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Sigara Kullanımı:</div>
          <div class="detail-value" [innerHTML]="highlight(v.smokingUsageInformation)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Alkol Kullanımı:</div>
          <div class="detail-value" [innerHTML]="highlight(v.alcoholUseInformation)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Alerjiler:</div>
          <div class="detail-value" [innerHTML]="highlight(v.allergies)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Kronik Hastalıklar:</div>
          <div class="detail-value" [innerHTML]="highlight(v.chronicDiseases)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Cerrahi Geçmiş:</div>
          <div class="detail-value" [innerHTML]="highlight(v.surgicalHistory)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Yaralanma Geçmişi:</div>
          <div class="detail-value" [innerHTML]="highlight(v.injuryHistory)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Soygeçmiş:</div>
          <div class="detail-value" [innerHTML]="highlight(v.familyHistoryNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Muayene Notu:</div>
          <div class="detail-value" [innerHTML]="highlight(v.inspectionNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Kontrol Notu:</div>
          <div class="detail-value" [innerHTML]="highlight(v.controlNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Tetkik Önerisi:</div>
          <div class="detail-value" [innerHTML]="highlight(v.investigationRecommendation)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Konsültasyon:</div>

          <div class="detail-value">

            <div *ngIf="v.consultation?.requestedDoctor">
              Doktor: {{ v.consultation.requestedDoctor }}
            </div>

            <div *ngIf="v.consultation?.requestedSection">
              Bölüm: {{ v.consultation.requestedSection }}
            </div>

            <div *ngIf="v.consultation?.desiredSituation">
              Durum: {{ v.consultation.desiredSituation }}
            </div>

            <span *ngIf="
                !v.consultation?.requestedDoctor &&
                !v.consultation?.requestedSection &&
                !v.consultation?.desiredSituation
              ">
              -
            </span>

          </div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Tedavi Notu:</div>
          <div class="detail-value" [innerHTML]="highlight(v.treatmentNote)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Sürekli Kullanılan İlaçlar:</div>
          <div class="detail-value" [innerHTML]="highlight(v.medicationsTakesRegularly)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Reçeteler:</div>
          <div class="detail-value" [innerHTML]="highlight(v.prescriptions)"></div>
        </div>

        <div class="detail-row">
          <div class="detail-label">Başvuru Hareketleri:</div>

          <div class="detail-value">

            <ul *ngIf="v.applicationMovements?.length; else noMovements" class="movement-list">
              <li *ngFor="let movement of v.applicationMovements">
                {{ movement }}
              </li>
            </ul>

            <ng-template #noMovements>
              -
            </ng-template>

          </div>
        </div>

      </div>

    </div>

  </div>

</div>

<div class="text-center p-4" *ngIf="!loading && !isSuccess">
  Bu hastanın geçmişi bulunamadı.
</div>